const numberToFormat = {}

function convertNumberToString (numberDouble) {
  let parts = numberDouble.toString().split(".")
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    return parts.join(".")
}

numberToFormat.install = function (Vue) {
  Vue.filter('numberFormatDecimal', (val) => {
    return val ? convertNumberToString(val) : '0'
  })
}

export default numberToFormat



// WEBPACK FOOTER //
// ./src/filters/numbers.js